import {Component} from '@angular/core';
import {ChargeSetupsService, ChargeSetupDto} from '@app/api/dmc';
import {FormApiService} from '@app/core/services/form-api.service';
import {FormGroup} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-chargeinformation-chargesetup-remove',
  imports: [
    TranslatePipe
  ],
  templateUrl: './chargeinformation-chargesetup-remove.component.html',
  styleUrl: './chargeinformation-chargesetup-remove.component.css'
})
export class ChargeinformationChargesetupRemoveComponent {
  public chargeInformationId?: string;
  public chargeSetupDto?: ChargeSetupDto;

  constructor(
    private readonly chargeSetupsService: ChargeSetupsService,
    private readonly formApiService: FormApiService,
  ) {
  }

  public remove(): void {
    if (this.chargeInformationId && this.chargeSetupDto?.id) {
      const formGroup: FormGroup = new FormGroup({});
      this.formApiService.submit(
        formGroup,
        () => this.chargeSetupsService.chargeInformationsChargeInformationIdChargeSetupsIdDelete(
          this.chargeInformationId!,
          this.chargeSetupDto!.id!),
        {
          successMessage: 'chargeSetup.chargeSetupRemoved',
          closeModal: true,
        }
      )
    }
  }
}
